import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { map, tap, switchMap, mergeMap, filter, concatMap, takeUntil } from 'rxjs/operators';
import { concat, forkJoin, merge, Observable, Subject } from 'rxjs';
import {Router, ActivatedRoute} from '@angular/router'
import {AuthService} from '../../Services/auth.service';
import {DataService} from '../../Services/data.service';
import * as _ from 'underscore';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConsentModalComponent } from '../consent-modal/consent-modal.component';
import { PopUpModalComponent } from '../pop-up-modal/pop-up-modal.component';
import { CommonAppService } from '../../Services/common-app.service';
import { appConst } from '../../app.config';


@Component({
  selector: 'app-mc-drilldown',
  templateUrl: './mc-drilldown.component.html',
  styleUrls: ['./mc-drilldown.component.css']
})
export class McDrilldownComponent implements OnInit {

  subNotifier = new Subject();

  loaded : boolean = false;
  loading : boolean;
  //not use
  private states = [{ "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "American Samoa", "abbreviation": "AS" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, { "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, { "name": "District Of Columbia", "abbreviation": "DC" }, { "name": "Federated States Of Micronesia", "abbreviation": "FM" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Guam", "abbreviation": "GU" }, { "name": "Hawaii", "abbreviation": "HI" }, { "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, { "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Marshall Islands", "abbreviation": "MH" }, { "name": "Maryland", "abbreviation": "MD" }, { "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, { "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, { "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, { "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Northern Mariana Islands", "abbreviation": "MP" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, { "name": "Oregon", "abbreviation": "OR" }, { "name": "Palau", "abbreviation": "PW" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Puerto Rico", "abbreviation": "PR" }, { "name": "Rhode Island", "abbreviation": "RI" }, { "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, { "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virgin Islands", "abbreviation": "VI" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, { "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" }];
  groupType =  JSON.parse(localStorage.getItem('authorizationData'))?.groupType;
  groupInfo : any = {
    
  };
  smMCDD : any = {};
  consentStatus : boolean = false;
  validGroup : boolean = false;
  private mcID : number; 
  drilldownMCID : number;
  users : any;
  iccInfo : any;
  subUsers : any;
  adminInfo : any;
  consentRecords : any;
  consentRecordColumns = ['TSPCompanyName', 'ModifiedDate', 'TemplateType'];
  

  constructor(private dataService : DataService, 
    private authService : AuthService,
    private activatedRouter : ActivatedRoute,
    private router : Router,
    private dialog : MatDialog,
    private commonAppService : CommonAppService,
    @Inject(DOCUMENT) private document : Document ) { 

  }

  private getsmMCDD() {
    this.smMCDD.DashboardBtn = false;
    this.smMCDD.ReportCardBtn = false;
    let authData = JSON.parse(localStorage.getItem('authorizationData'));

    this.authService._getsmData(authData.userRole, authData.groupType, "MCDrillDownHtml").subscribe(
      (result) => {
        if(!this.authService._accessFilter(result, "MCDrillDownHtml")){
          this.router.navigate(['/']);
        }

        this.smMCDD.DashboardBtn = this.authService._accessFilter(result, "DashboardBtn");
        this.smMCDD.ReportCardBtn = this.authService._accessFilter(result, "ReportCardBtn");                       
        this.smMCDD.DeActivateBtn = this.authService._accessFilter(result, "DeActivateBtn");                       
      }
    );

    return this.smMCDD;
  }

  private loadData() {
    // get list of mutual customers to perform validation on state-param
    this.dataService._getMutualCustomers()
    .pipe(tap(mut => {
      this.users = mut;
      this.loading = false;
      // loop through all MC's to see if current state-param is a MC
      this.users.map(group => {
        if(group.McId === this.mcID)
        {
          this.validGroup = true;
        }
      });

      // If valid MC - make API call to get MC information
      if(this.validGroup)
      {
        this.dataService._getGroupInfo(this.mcID, 1001)
        .pipe(
          concatMap(result => {
            this.groupInfo = result;
            return this.dataService._getGroupInfo(result.IccID, 1002) 
            }
          ),
          concatMap(IccResult => 
            {
              this.iccInfo = IccResult;
              return this.dataService._getSubUsers(this.groupInfo.GroupId, this.groupInfo.GroupType)
            }
          ),
          concatMap(subUserInfo => 
            {
              this.subUsers = subUserInfo;
              this.adminInfo = _.filter(this.subUsers, { UserId: this.groupInfo.AdminId });
              this.adminInfo = this.adminInfo[0];

              this.loaded = true;
              return this.dataService._getFullConsentHistory(this.mcID);
            }
          ),
          concatMap(result => 
            {
              this.consentRecords = result;
              if(this.consentRecords.length)
              {
                //todo:
                //generateTable();
              }
              return this.dataService._getMCStatus(this.mcID);
            }
          )
        ).pipe(takeUntil(this.subNotifier)).subscribe(
          result =>
          {
            if(result && result !== 'null')
            {
              if(result.ConsentStatus === 1)
              {
                this.consentStatus = true;
              }
            }
          }
        );
      }
      else
      {
        this.loaded = true;
      }

    })).pipe(takeUntil(this.subNotifier)).subscribe();
  }


  open(record : any) {
    let dialogRef = this.dialog.open(ConsentModalComponent, {
      data: record,
      width: '30%',
      //height: '35%',
      id: 'modal-component', //to match the global css
      position: { 
        top: '1%',
        left :'35%',
        right: ''
      }
    });
  }

  deActivate() {

    let popUpModelConfig = {
      title: "Please Confirm",
      message: "Are you sure you want to DeActivate this Account?",
      buttons: [{
          label: "Confirm",
          action: "confirm"
      }],
      note: 'Insured Account can NOT be reverted once being Deactivated!',
      isReadOnlyNote: true
    };


    let dialogRef = this.dialog.open(PopUpModalComponent, {
      data: popUpModelConfig,
      width: '30%',
      //height: '35%',
      id: 'modal-component', //to match the global css
      position: { 
        top: '1%',
        left :'35%',
        right: ''
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let authData = JSON.parse(localStorage.getItem('authorizationData'));
        let param = {
          iccUserId : authData.userID,
          iccUserRole : authData.userRole,
          iccUserGroupId : authData.groupID,
          mcId : this.groupInfo.GroupId
      };

      this.dataService._deActivateMC(param).pipe(takeUntil(this.subNotifier)).subscribe(
        result =>
        {
          if(result)
          {
            this.loadData();
            this.commonAppService._snackBar(true,'Insured has been DeActivated!', 3000);

            //07-26-2023 add the email notification to Admins when a client is deactivated
            this.dataService._getSubUsers(this.groupInfo.IccID, appConst.groupType.ICC).pipe(
              concatMap(
                result => {
                  let iccAdminLst = _.filter(result, (item) => { return item.Role == appConst.role.admin});
                  let domain = this.document.location.origin;

                  //iccAdminLst = [{email:'lliu@energi.com'}];
                  let iccAdmins = '';
                  iccAdminLst.forEach((item => {
                    iccAdmins += item.email + ';'
                  }));

                  //iccAdmins = 'lliu@etechnologyservices.com;';
                  
                  return this.dataService._sendEmail(iccAdmins, 'ICC Admins', 'noreply@telematicexchange.com', 'Telematic Exchange', 
                    'Client DeActivated', `MCid of ${this.groupInfo.GroupId}, ${this.groupInfo.CompanyName} has been DeActivated by Admin of ${param.iccUserId} From ${domain}`)
                })
              )
              .pipe(takeUntil(this.subNotifier))
            .subscribe();
            //07-26-2023 add the email notification to Admins when a client is deactivated
          }
          else{
            this.commonAppService._snackBar(false,'Failed to DeActivate Insured!', 3000);
          }
        },error =>
        {
          this.commonAppService._snackBar(false,'Failed to DeActivate Insured!', 3000);
        }
      );
      }
    });
  }





  ngOnInit(): void {
    this.dataService._getGroupInfo().pipe(takeUntil(this.subNotifier)).subscribe(
      (result) => { this.groupInfo = result; }
    );

    this.getsmMCDD();
    
    //get parameter from the route url
    this.mcID =  Number(this.activatedRouter.snapshot.paramMap.get('mcID'));
    this.drilldownMCID = Number(this.activatedRouter.snapshot.paramMap.get('mcID'));

    this.loadData();


    //this[functionName]();
  }

  ngOnDestroy() {
    //unsubscribe
    this.subNotifier.next();
    this.subNotifier.complete();
  }
  

}
